var Handlebars = require("handlebars/dist/handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n<div class=\"horizontal-address\">\r\n  <span class=\"address-line\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"formattedAddress") || (depth0 != null ? lookupProperty(depth0,"formattedAddress") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"formattedAddress","hash":{},"data":data,"loc":{"start":{"line":21,"column":29},"end":{"line":21,"column":49}}}) : helper)))
    + "</span>\r\n</div>";
},"useData":true});